<template>
	<section @click="modal__handleClick">

		<slot/>

	</section>
</template>

<script>

export default {

	name: 'press-kit',

	props: {
	},

	methods: {
		modal__handleClick( event ) {
			this.$modal.show({
				template: `
				<div class="PressKitModal">
					<a href="#modal-close" title="Close" class="PressKitModal-close" @click="$emit('close')"><svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="PressKit-Modal" transform="translate(-1281.000000, -231.000000)" fill="#8C8C8C" fill-rule="nonzero">
								<g id="PressKit-Modal" transform="translate(90.000000, 187.000000)">
									<g id="Button/Close" transform="translate(1191.000000, 44.000000)">
										<path d="M21.7664657,0.336369556 C22.3556264,-0.144158381 23.2246888,-0.109834957 23.7738636,0.439339828 C24.35965,1.02512627 24.35965,1.97487373 23.7738636,2.56066017 L23.7738636,2.56066017 L14.356,11.977 L24.0316761,21.6525433 C24.6174625,22.2383297 24.6174625,23.1880772 24.0316761,23.7738636 C23.4825013,24.3230384 22.6134389,24.3573618 22.0242782,23.8768339 L21.9103558,23.7738636 L12.235,14.098 L2.56066017,23.7738636 L2.44673776,23.8768339 C1.85757702,24.3573618 0.988514613,24.3230384 0.439339828,23.7738636 C-0.146446609,23.1880772 -0.146446609,22.2383297 0.439339828,21.6525433 L0.439339828,21.6525433 L10.114,11.977 L0.697152328,2.56066017 C0.111365891,1.97487373 0.111365891,1.02512627 0.697152328,0.439339828 C1.24632711,-0.109834957 2.11538952,-0.144158381 2.70455026,0.336369556 L2.81847267,0.439339828 L12.235,9.856 L21.6525433,0.439339828 Z" id="Gray-X"></path>
									</g>
								</g>
							</g>
						</g>
					</svg></a>

				   <div class="PressKitModal-body">
						<contact-form/>
					</div>
				</div>`,
				props: []},
				{
					name: this.name,
					headshot: this.headshot,
					bio: this.bio,
					title: this.title,
					links: this.links
				},
				{
					classes: 'isContactForm',
					adaptive: true,
					scrollable: true,
					width: 500,
					height: 'auto'
				})
			event.preventDefault()
		},
	}

}
</script>
